








































































































import { Component, Vue } from "vue-property-decorator";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import { getRoutePath } from "@/router/routes";
import { getStoreUsersApi } from "@/typescript/api_client/emesh_api/users/store_users_api";
import {
  GetStoreUsersResponse,
  StoreUser
} from "@/typescript/api_client/emesh_api/users/types";

export { GetStoreUsersResponse, StoreUser };

@Component({
  components: {
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    ButtonComponent,
    EllipsisComponent,
    MenubarComponent
  }
})
export default class extends Vue {
  // @Prop()
  // sensors: any;

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  // getYYYYMMDD(date: string | null): string {
  //   if (date == null) {
  //     return "";
  //   } else {
  //     return date.slice(0, 10);
  //   }
  // }

  // zeroPadding(num: number, length: number) {
  //   return fillZero(num, length);
  // }

  // getCategoryImage(iconNum: number, status: "on" | "off"): string {
  //   return getEquipmentIcon(iconNum, status);
  // }
  users: StoreUser[] = [];

  // 有効フラグ
  get isValid() {
    return 1;
  }

  created() {
    this.serUsers();
  }

  serUsers() {
    getStoreUsersApi(this.$route.params.store_id).then(
      (resp: GetStoreUsersResponse) => {
        this.users = resp;
      }
    );
  }

  // 警告メール通知がONならtrueを返す
  isAlertOn(alertFilter): boolean {
    // 2:警報メールを飛ばさない
    if (alertFilter === 2) return false;
    // 0:発生・復旧ともに警報メールを飛ばす、1:警報発生時のみメールを飛ばす
    return true;
  }
}
